<div class="logout">
  <header>
    <div class="close-button-container">
      <button class="close-button" (click)="closeDialog()">
        <app-icon name="close" colour="black" />
      </button>
    </div>
  </header>
  <h1>Are you sure you want to log out?</h1>
  <app-divider [dividerConfig]="{
    color: '#14448F',
    orientation: 'horizontal',
    thickness: '1.5px'
  }" />
  <p>If you log out, you will need to log in again to access this portal.</p>
  <div class="button-container">
    <button class="secondary full" (click)="logout()">Log out</button>
    <button class="primary" (click)="closeDialog()">Cancel</button>
  </div>
</div>